import React, { useState } from 'react';
import { EditText } from '../../../../../../component/ui/edit-text/edit-text';
import { Button } from 'primereact/button';
import { createNewRatePriceForLecturerOperations } from '../operations/create-new-rate-price-for-lecturer-operations';
import { Dropdown } from 'primereact/dropdown';
import { PaymentType } from '../../../../../../api/types/settings/lecturers/settings-lecturers-rate-type';

interface AddNewRateTypeDialogModel {
  closeDialog: () => void;
}
export const AddNewRateTypeDialog: React.FC<AddNewRateTypeDialogModel> = ({
  closeDialog,
}) => {
  const [serviceType, setServiceType] = useState('');
  const [loading, setLoading] = useState(false);

  const [selectedPaymentServiceType, setSelectedPaymentServiceType] =
    useState<PaymentType>(PaymentType.Hourly);
  const paymentTypeOptions = [
    { label: 'שעה אקדמית (45 דקות)', value: PaymentType.Discrete },
    { label: 'שעה עגולה (60 דקות)', value: PaymentType.Hourly },
  ];

  const handleOnSubmit = async () => {
    await createNewRatePriceForLecturerOperations(
      serviceType,
      selectedPaymentServiceType,
      closeDialog,
      setLoading,
    );
  };

  return (
    <div>
      <EditText title={'שם סוג התשלום'} onChange={setServiceType} />

      <div style={{ fontSize: '14px', color: '#4b5563' }}>סוג תשלום</div>
      <Dropdown
        style={{
          width: '100%',
          height: '40px',
          alignItems: 'center',
          marginTop: '4px',
          marginBottom: '8px',
        }}
        value={selectedPaymentServiceType}
        onChange={(e) => setSelectedPaymentServiceType(e.value)}
        options={paymentTypeOptions}
        optionLabel="label"
        placeholder="בחר את סוג השרות"
      />
      <div style={{ height: '8px' }} />
      <div
        style={{ height: '100%', display: 'flex', justifyContent: 'center' }}
      >
        <Button
          style={{ height: '30px' }}
          label={'אישור'}
          onClick={handleOnSubmit}
          loading={loading}
        />
      </div>
    </div>
  );
};
